export default function Footer() {
  return (
    <footer id="footer" className="w-full bg-gradient-to-b from-primary-800 to-primary-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-background-50 mb-4">51爆料</h3>
            <p className="text-sm leading-relaxed text-background-50/65">
              全网吃瓜第一站。每日追踪娱乐圈八卦、网红动态、社会热点，覆盖100+平台，日均更新200+条爆料。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#ranking" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">热搜榜单</a>
              <a href="#index" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">爆料合集</a>
              <a href="#media" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">视频爆料</a>
              <a href="#faq" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">热门话题</h4>
            <div className="flex flex-col gap-2">
              <a href="#topics" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">顶流塌房</a>
              <a href="#topics" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">网红翻车</a>
              <a href="#topics" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">综艺名场面</a>
              <a href="#topics" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">影视争议</a>
              <a href="#topics" className="text-sm text-background-50/65 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">恋情曝光</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/65 leading-relaxed">
              诚邀优质内容平台与媒体伙伴加入合作，共同打造更好的吃瓜体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/45 text-center sm:text-left">
            &copy; 2024-2026 51爆料 51baoliao.com 版权所有 | 本站内容来源于公开信息聚合，仅供消遣娱乐
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-50/45 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-background-50/45 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}